import { types } from '../../../constants/ActionTypes'

const initialState = {
  anchorEl: null,
  selectedMenu: '',
  isVisibleChatCard: true,
}

const chatMenu = (state = initialState, action) => {
  switch (action.type) {
    case types.router.LOCATION_CHANGE:
      return { ...state, anchorEl: null }
    case types.chatMenu.OPEN:
      return { ...state, anchorEl: action.anchorEl }
    case types.chatMenu.CLOSE:
      return { ...state, anchorEl: null }
    case types.chatMenu.SELECTED_MENU:
      return { ...state, selectedMenu: action.selectedMenu }
    case types.chatMenu.SHOW_CHAT_CARD:
      return { ...state, isVisibleChatCard: true, selectedMenu: '' }
    case types.chatMenu.HIDE_CHAT_CARD:
      return { ...state, isVisibleChatCard: false, selectedMenu: '' }
    default:
      return state
  }
}

export default chatMenu


// WEBPACK FOOTER //
// ./src/reducers/Common/Chat/ChatMenu.js